import { colors } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { red, blue, yellow } from '@mui/material/colors';
import shadows from './shadows';
import typography from './typography';
// Dark theme
const theme = createTheme({
  palette: {
    type: 'dark',
    background: {
      default: colors.common.dark,
      progressBar: yellow['A400'],
      paper: colors.common.dark
    },
    primary: {
      main: '#26292C',
      light: '#424242',
      dark: 'rgb(26, 35, 39)',
      contrastText: '#ffffff',
      activeColor: '#0000A0'
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#424242',
    },
    secondary: {
      main: '#e0e0e0',
      light: 'rgb(255, 197, 112)',
      dark: 'rgb(200, 147, 89)',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    titleBar: {
      main: '#555555',
      contrastText: '#ffffff'
    },
    error: {
      main: red.A400
    }
  },
  shadows,
  typography,
  components: {
    MuiAppBar: {
      defaultProps: {
        enableColorOnDark: true,
      },
    }
  }
});

export default theme;
